import { useTranslation } from 'react-i18n-lite'

import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;

  @media (min-width: 480px) {
    font-size: 32px;
    line-height: 48px;
  }
`

const ErrorImage = styled.img`
  width: 288px;
  margin-bottom: 16px;

  @media (min-width: 480px) {
    width: 410px;
  }
`

export default function DuplicateInteractionError() {
  const { t } = useTranslation()

  return (
    <Container>
      <ErrorImage src='/duplicate_interaction.png' alt={t('system.error')} />
      <span>{t('duplicate-interaction-error')}</span>
    </Container>
  )
}
